export default "__VITE_ASSET__5dc979bc__"